module.exports = __webpack_public_path__ + "static/media/h1.1d86dd3d.jpeg";